import { type PredictionStatus, predictionStatusSchema } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import predictionStatuses to the global cache.
 *
 * @param predictionStatuses - array of Prediction Statuses
 */
function importPredictionStatuses(predictionStatuses: PredictionStatus[]) {
  const parsedResult = filteredArray(predictionStatusSchema).safeParse(
    predictionStatuses,
  );
  if (parsedResult.success) {
    importEntities(QueryKeys.predictions.global, parsedResult.data);
  }
}

export { importPredictionStatuses };
